module.exports = __webpack_public_path__ + "static/https-server-browser-warning-62281507235b6d244bba07fc5ec04eb6.png";